import { render, staticRenderFns } from "./panel_activity.vue?vue&type=template&id=07bb59f2&scoped=true&"
import script from "./panel_activity.vue?vue&type=script&lang=js&"
export * from "./panel_activity.vue?vue&type=script&lang=js&"
import style0 from "./panel_activity.vue?vue&type=style&index=0&id=07bb59f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb59f2",
  null
  
)

export default component.exports